import { useState } from 'react'
import { client } from '../lib/api'

const REPORT_REASONS = [
  'Harassment or stalking',
  'Fake profile / catfishing',
  'Underage or minor safety',
  'Non-consensual or explicit content',
  'Scam or fraud',
  'Hate or extremist content',
  'Other',
]

export function ReportBlock({
  reportedId,
  targetType,
  targetId,
  notify,
  onDone,
}: {
  reportedId: string
  targetType: 'user' | 'photo' | 'message'
  targetId: string
  notify: (msg: string) => void
  onDone?: () => void
}) {
  const [open, setOpen] = useState(false)
  const [reason, setReason] = useState(REPORT_REASONS[0])
  const [details, setDetails] = useState('')
  const [busy, setBusy] = useState(false)

  const submitReport = async () => {
    setBusy(true)
    try {
      await client.report({ targetType, targetId, reason, details: details.trim() || undefined, reportedId })
      notify('Report submitted. Our team will review.')
      setOpen(false)
      onDone?.()
    } catch (e) {
      notify((e as Error).message)
    } finally {
      setBusy(false)
    }
  }

  const block = async () => {
    setBusy(true)
    try {
      const res = await client.blockUser(reportedId)
      notify((res as { message?: string }).message ?? 'Blocked')
      setOpen(false)
      onDone?.()
    } catch (e) {
      notify((e as Error).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <button type="button" className="text-button safety-action" onClick={() => setOpen(true)}>
        Report / block
      </button>
      {open && (
        <>
          <div className="drawer-backdrop" onClick={() => setOpen(false)} />
          <div className="drawer" role="dialog" aria-label="Report or block">
            <div className="drawer-head">
              <h2>Safety</h2>
              <button type="button" className="button secondary" onClick={() => setOpen(false)}>
                Close
              </button>
            </div>
            <div className="field">
              <label>Reason</label>
              <select className="input" value={reason} onChange={(e) => setReason(e.target.value)}>
                {REPORT_REASONS.map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </select>
            </div>
            <div className="field">
              <label>Details (optional)</label>
              <textarea className="input" rows={3} value={details} onChange={(e) => setDetails(e.target.value)} />
            </div>
            <div className="modal-actions">
              <button className="button primary" disabled={busy} onClick={() => void submitReport()}>
                Submit report
              </button>
              <button className="button secondary" disabled={busy} onClick={() => void block()}>
                Block member
              </button>
            </div>
            <p className="page-sub">Blocking is immediate and private. Reports go to the human moderation queue.</p>
          </div>
        </>
      )}
    </>
  )
}
